import React, { useState } from 'react'
import { Box, Button, FormControl, Grid, TextField } from '@mui/material'
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import { useUserStore } from 'stores/users'
import { colors } from '~constants/colorsPallete'
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded'

interface DashboardFiltersProps {
  onFilterChange: (filters: any) => void
}

const DashboardFilters: React.FC<DashboardFiltersProps> = ({ onFilterChange }) => {
  const [date, setDate] = useState<string>('')
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleChangeDate = (event: any) => {
    const formattedDate = dayjs(event).format('YYYY/MM/DD')
    setDate(formattedDate)
  }

  return !isOpen ? (
    <Grid container direction="row" justifyContent="flex-end" mb={2}>
      <Button
        disableElevation
        variant="contained"
        endIcon={<FilterAltRoundedIcon />}
        sx={{ backgroundColor: colors['gray.500'], borderRadius: 100 }}
        onClick={() => {
          setIsOpen(!isOpen)
        }}
      >
        Abrir Filtros
      </Button>
    </Grid>
  ) : (
    <>
      <Grid container direction="row" justifyContent="flex-end" mb={2}>
        <Grid item xs={12} display={'flex'} justifyContent={'flex-end'} mb={0} pb={0}>
          <Button
            disableElevation
            variant="contained"
            endIcon={<FilterAltRoundedIcon />}
            sx={{ backgroundColor: colors['gray.500'], borderRadius: 100 }}
            onClick={() => {
              setIsOpen(!isOpen)
            }}
          >
            Fechar Filtros
          </Button>
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        gap={1}
        p={3}
        mb={2}
        border={'1px solid #E0E0E0'}
        borderRadius={'3px'}
        sx={{ backgroundColor: colors['white.300'] }}
      >
        <Grid item>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <FormControl fullWidth>
              <DatePicker
                label="Mês de visualização"
                format="MM/YYYY"
                views={['month', 'year']}
                defaultValue={dayjs()}
                sx={{
                  backgroundColor: colors.white,
                  borderRadius: 2,
                  border: 0,
                  '& fieldset': { border: 'none' },
                }}
                onChange={(e) => {
                  setDate(dayjs(e).format('YYYY/MM/DD'))
                  handleChangeDate(dayjs(e).format('YYYY/MM/DD'))
                }}
              />
            </FormControl>
          </LocalizationProvider>
        </Grid>

        <Grid item xl={12} sm={12} md={12} lg={12} xs={12}>
          <Box display="flex" flexDirection="row" alignContent={'center'} justifyContent={'flex-end'} mt={3}>
            <Button
              disableElevation
              variant="contained"
              sx={{ backgroundColor: colors.success, borderRadius: 100, mr: 2 }}
              onClick={() => {
                onFilterChange({ date })
              }}
            >
              Filtrar
            </Button>
            <Button
              disableElevation
              variant="outlined"
              sx={{ borderColor: colors.error, color: colors.error, borderRadius: 100 }}
              onClick={() => {
                setDate('')
                onFilterChange({ date: '' })
              }}
            >
              Limpar filtros
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default DashboardFilters
